import styled from 'styled-components'

export const ModalActions = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
`

export const SelectedTagsContainer = styled.div`
	width: 100%;
	align-items: flex-start;
`

export const TagsRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	align-items: center;
`

export const TagsLabel = styled.span`
	font-size: 14px;
	font-weight: 500;
	color: ${props => props.theme.colors.text.primaryText};
	margin-right: 8px;
`
